import React from 'react';
import { motion } from 'framer-motion';
import { mascot } from '../../data/mock';
import { Download, Globe } from 'lucide-react';
import { ParticleBackground } from '../ui/ParticleBackground';
import { useTranslation } from 'react-i18next';
import { STORE_LINKS } from '../../constants/links';

export const FinalCTA = () => {
  const { t } = useTranslation();
  return (
    <section id="download" className="relative py-24 lg:py-32 overflow-hidden z-10 text-white bg-slate-950">
      {/* Particle Background */}
      <ParticleBackground />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {/* Left: Huge Monkey */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="hidden lg:flex lg:col-span-5 justify-center"
          >
            <motion.img 
              animate={{ y: [0, -15, 0] }}
              transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
              src={mascot.pro} 
              alt="Monito Business" 
              className="w-full max-w-[20rem] drop-shadow-2xl"
            />
          </motion.div>

          {/* Right: Text and Buttons */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7 flex flex-col items-center lg:items-start text-center lg:text-left"
          >
            {/* Mobile monkey (visible only on small screens) */}
            <motion.img 
              animate={{ y: [0, -5, 0] }}
              transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
              src={mascot.pro} 
              alt="Monito Business" 
              className="w-24 mb-8 drop-shadow-xl lg:hidden"
            />

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-8">
              {t('finalCTA.title')}
            </h2>
            <div className="text-lg md:text-xl text-blue-100/90 mb-10 font-medium space-y-3">
              <p>{t('finalCTA.p1')}</p>
              <p>{t('finalCTA.p2')}</p>
              <p>{t('finalCTA.p3')}</p>
              <p>{t('finalCTA.p4')}</p>
              <p className="text-3xl md:text-4xl font-black text-white pt-6">{t('finalCTA.highlight')}</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start w-full sm:w-auto">
              <a 
                href={STORE_LINKS.ios}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-white text-slate-900 px-8 py-4 rounded-2xl hover:scale-105 transition-transform shadow-lg shadow-[#0DA2E7]/20 w-full sm:w-auto justify-center"
              >
                <Download className="w-6 h-6" />
                <div className="text-left">
                  <div className="text-xs text-slate-500 font-semibold uppercase tracking-wider">{t('finalCTA.downloadLabel')}</div>
                  <div className="text-lg font-black leading-none mt-1">App Store</div>
                </div>
              </a>
              <a 
                href={STORE_LINKS.android}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-white text-slate-900 px-8 py-4 rounded-2xl hover:scale-105 transition-transform shadow-lg shadow-[#0DA2E7]/20 w-full sm:w-auto justify-center"
              >
                <Download className="w-6 h-6" />
                <div className="text-left">
                  <div className="text-xs text-slate-500 font-semibold uppercase tracking-wider">{t('finalCTA.downloadLabel')}</div>
                  <div className="text-lg font-black leading-none mt-1">Google Play</div>
                </div>
              </a>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};
